import { ApplicationController, useTransition, useIntersection } from 'stimulus-use';

export default class extends ApplicationController {
  static values = {
    delay: Number,
  };

  connect() {
    window.addEventListener('turbo:morph', () => {
      this.enable();
    });
    this.enable();
  }

  enable() {
    useIntersection(this, {
      threshold: 0.3,
    });
    useTransition(this, {
      hiddenClass: 'opacity-0',
      transitioned: false,
      preserveOriginalClass: false,
    });
  }

  appear(entry) {
    if (entry.isIntersecting) {
      this.open();
    }
  }

  open() {
    if (this.delayValue) {
      setTimeout(() => {
        this.enter();
      }, this.delayValue * 1000);
    } else {
      this.enter();
    }
  }
}
